import createDebug from 'debug';

const debug = createDebug('ethsign');

export function log(messageTemplate: string, ...args: any[]): void {
  debug(messageTemplate, ...args);
}
